import { PageScheme } from '@/config/types';

import { DYNAMIC_PAGE_PATHS } from '../../shared/pathRoutes';

export const PAGE_BORROWER_LIST: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.BORROWER_LIST,
  schemesByRoles: [
    {
      roles: [],
      titleTextId: 'BORROWER_LIST',
      widgets: [],
    },
  ],
  sections: [
    // {
    //   textId: undefined,
    //   schemesByRoles: [
    //     {
    //       roles: [...ALL_APP_ROLES],
    //       modules: [<OrderActivity />],
    //     },
    //   ],
    // },
  ],
};
